<script setup lang="ts">
import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic'

type ProductSelectorProps = {
  variationAttribute: ShopperProductsTypes.VariationAttribute
  productStoreLocation: ProductStoreLocation
}
const props = defineProps<ProductSelectorProps>()
const productStore = useProductStore(props.productStoreLocation)

const selectedVariation = ref<string>(productStore.selectedProduct?.variationValues?.[props.variationAttribute.id])
const selectOptions = computed(() => {
  return props.variationAttribute.values!.map((value: ShopperProductsTypes.VariationAttributeValue) => {
    return {
      label: value.name ?? value.value,
      value: value.value,
    }
  })
})

const onAttributeValueSelected = async () => {
  const newVariant = productStore.selectedProduct?.variants?.find((variant) => {
    return variant.variationValues?.[props.variationAttribute.id] === selectedVariation.value
  })
  if (!newVariant) return
  await productStore.getNewVariant(newVariant.productId)
}
</script>

<template>
  <div>
    <Select
      v-model="selectedVariation"
      :name="variationAttribute.name!"
      :label="variationAttribute.name!"
      :options="selectOptions"
      :select-test-id="`pdp-variation-${variationAttribute.id}`"
      required
      @change.stop="onAttributeValueSelected"
    />
  </div>
</template>

<style></style>
